module.exports = __webpack_public_path__ + "img/img-parts-sishu03.48b89f86.png";